module.exports = __webpack_public_path__ + "./assets/screenshot_home_tools.png";